import { NgModule } from '@angular/core';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';

@NgModule({
  imports: [AccordionModule],
  exports:[AccordionModule]
})

export class syncfusion_module {

}
